<template>
  <div v-if="eventHandler">
    <!-- Vue mount component but props is undefined -->
    <RawJsonToggler :json="eventHandler" />
    <!-- Event Handler -->
    <h1>{{ eventHandler.name }}</h1>
    <!-- Actions -->
    <Fieldset legend="Actions">
      <router-link
        tag="button"
        :to="{
          name: 'eventHandlerEdit',
          params: {
            eventHandlerName: eventHandlerName
          }
        }"
      >
        Edit
      </router-link>
      <button v-if="!readOnly" @click="removeEventHandler(eventHandler.name)">
        Remove
      </button>
    </Fieldset>
    <DataList :data="eventHandler" :attributes="attributes" />
    <!-- Actions -->
    <DataTable
      caption="Event Actions"
      :rowKeys="['name']"
      :rows="eventHandler.actions"
      :actions="[]"
      :columns="[{ name: 'action', type: 'text' }]"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DataTable from '@/components/DataTable.vue'
import DataList from '@/components/DataList.vue'
import Fieldset from '@/components/Fieldset.vue'
import RawJsonToggler from '@/components/RawJsonToggler.vue'

export default {
  name: 'EventHandler',
  props: ['eventHandlerName'],
  data() {
    return {
      attributes: [
        { name: 'name', type: 'text' },
        { name: 'event', type: 'text' },
        { name: 'active', type: 'boolean' }
      ]
    }
  },
  computed: mapState(['eventHandler', 'readOnly']),
  methods: {
    ...mapActions(['getEventHandler', 'removeEventHandler'])
  },
  created() {
    this.getEventHandler(this.eventHandlerName)
  },
  components: {
    DataTable,
    DataList,
    Fieldset,
    RawJsonToggler
  }
}
</script>
